import * as a from "vanilla-cookieconsent";
import { inject as S, ref as d, defineComponent as w, onMounted as y, openBlock as z, createElementBlock as E, Fragment as B, unref as h, renderSlot as g, createElementVNode as v, toDisplayString as m, watch as D } from "vue";
import { createDefu as A } from "defu";
const k = Symbol("CookieConsent"), C = typeof window > "u", N = {
  guiOptions: {
    consentModal: {
      layout: "box wide",
      equalWeightButtons: !0
    },
    preferencesModal: {
      equalWeightButtons: !0
    }
  },
  categories: {
    necessary: {
      enabled: !0,
      readOnly: !0
    },
    functional: {
      enabled: !1,
      readOnly: !1,
      services: {}
    },
    analytics: {
      enabled: !1,
      readOnly: !1,
      autoClear: {
        cookies: [{ name: /^_/ }]
      }
    }
  },
  language: {
    default: "de",
    translations: {
      de: {
        consentModal: {
          title: "Cookies &amp; Tracking",
          description: 'Wir verwenden Cookies, um das Nutzererlebnis auf unserer Webseite zu verbessern, unseren Datenverkehr zu analysieren, Inhalte zu personalisieren und Social Media-Funktionen bereitzustellen.<br /><br />Mehr Details erfahren Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.',
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Alle ablehnen",
          showPreferencesBtn: "Auswahl erlauben"
        },
        preferencesModal: {
          title: "Cookie-Einstellungen",
          acceptAllBtn: "Alle akzeptieren",
          acceptNecessaryBtn: "Alle ablehnen",
          savePreferencesBtn: "Einstellungen speichern",
          closeIconLabel: "Schliessen",
          sections: [
            {
              title: "Cookie Nutzung",
              description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um Ihr Online-Erlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie sich ein- oder austragen möchten, wann immer Sie wollen. Weitere Einzelheiten zu Cookies und anderen sensiblen Daten finden Sie in der vollständigen <a href="/datenschutz" class="cc-link">Datenschutzrichtlinie</a>.'
            },
            {
              title: "Notwendige Cookies",
              description: "Diese Cookies sind für das ordnungsgemäße Funktionieren meiner Website unerlässlich.",
              linkedCategory: "necessary",
              cookieTable: {
                headers: {
                  name: "Name",
                  description: "Description",
                  expiration: "Gültigkeit"
                },
                body: [
                  {
                    name: "CC Cookie",
                    description: "Speichern der Cookie auswahl",
                    expiration: "6 Monate"
                  },
                  {
                    name: "PHPSESSID",
                    description: "Speichern der Sprachauswahl",
                    expiration: "Session"
                  }
                ]
              }
            },
            {
              title: "Funktionale Cookies",
              description: "Diese Cookies ermöglichen die erweiterte Nutzung der Webseite, wie das laden von Videos welche über dritte Anbieter eingebunden werden oder das Absenden geschützter Formulare.",
              linkedCategory: "functional"
            },
            {
              title: "Analyse Cookies",
              description: "Statistik-Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem sie Informationen sammeln und melden.",
              linkedCategory: "analytics",
              cookieTable: {
                headers: {
                  name: "Name",
                  description: "Description",
                  expiration: "Gültigkeit"
                },
                body: [
                  // {
                  //   name: 'Google Analytics',
                  //   description: 'Cookies von Google Analytics',
                  //   expiration: '2 Wochen',
                  // },
                  // {
                  //   name: 'Facebook',
                  //   description: 'Cookies von Facebook',
                  //   expiration: '2 Wochen',
                  // },
                ]
              }
            }
          ]
        }
      }
    }
  }
}, W = A((s, i, e) => i === "sections" ? (s[i] = e, !0) : !1);
function j(s, i) {
  if (C || window.prerender) {
    s.provide(k, void 0);
    return;
  }
  const e = W(i ?? {}, N), c = d({}), u = () => {
    const n = {}, t = a.getUserPreferences();
    t.acceptedCategories.forEach((r) => {
      n[r] = !0;
    }), t.rejectedCategories.forEach((r) => {
      n[r] = !1;
    }), Object.entries(t.acceptedServices).forEach(([r, f]) => {
      f.forEach((p) => {
        n[`${r}.${p}`] = !0;
      });
    }), Object.entries(t.rejectedServices).forEach(([r, f]) => {
      f.forEach((p) => {
        n[`${r}.${p}`] = !1;
      });
    }), c.value = n;
  };
  function l(n, t) {
    t || ([n, t] = n.split(".")), a.showPreferences(), a.hidePreferences(), a.acceptService(
      [t, ...a.getUserPreferences().acceptedServices[n]],
      n
    );
  }
  a.run({
    ...e,
    onConsent: u,
    onChange: u
  });
  const o = {
    ...a,
    services: c,
    acceptService: l
  };
  return s.provide(k, o), s.config.globalProperties.$cookieconsent = o, o;
}
function $(s) {
  return (i) => j(i, s);
}
function b() {
  return S(k);
}
const P = { class: "cc-rejected" }, x = /* @__PURE__ */ w({
  __name: "CookieGuard",
  props: {
    service: {},
    rejectText: { default: "You have not accepted the usage of {service}." },
    buttonText: { default: "Accept {service}" }
  },
  setup(s) {
    const i = s, e = b(), { allowed: c } = M(i.service), u = d(!0), l = d("");
    return y(() => {
      var t, r;
      u.value = !1;
      const [o, n] = i.service.split(".");
      l.value = ((r = (t = e == null ? void 0 : e.getConfig().categories[o].services) == null ? void 0 : t[n]) == null ? void 0 : r.label) ?? "";
    }), (o, n) => {
      var t;
      return u.value ? (z(), E(B, { key: 0 }, [], 64)) : h(c) ? g(o.$slots, "default", { key: 1 }) : g(o.$slots, "rejected", {
        key: 2,
        serviceName: l.value,
        acceptService: (t = h(e)) == null ? void 0 : t.acceptService
      }, () => [
        v("div", P, [
          v("div", null, m(o.rejectText.replace("{service}", l.value)), 1),
          v("button", {
            onClick: n[0] || (n[0] = () => {
              var r;
              return (r = h(e)) == null ? void 0 : r.acceptService(o.service);
            })
          }, m(o.buttonText.replace("{service}", l.value)), 1)
        ])
      ]);
    };
  }
});
function M(s) {
  const i = d(!1);
  if (C)
    return { allowed: i };
  const e = b();
  return e && D(e.services, (c) => {
    i.value = c[s] ?? !1;
  }, { immediate: !0 }), {
    allowed: i,
    acceptService: e == null ? void 0 : e.acceptService
  };
}
export {
  k as CookieConsentSymbol,
  x as CookieGuard,
  $ as createCookieConsent,
  b as useCookieConsent,
  M as useCookieGuard
};
//# sourceMappingURL=index.mjs.map
